module.exports = (__webpack_require__("jaIgFIJB"))("./node_modules/create-react-class/index.js");